/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiMemberDtoAddMemberObjectDto } from './WebApiMemberDtoAddMemberObjectDto';
import {
    WebApiMemberDtoAddMemberObjectDtoFromJSON,
    WebApiMemberDtoAddMemberObjectDtoFromJSONTyped,
    WebApiMemberDtoAddMemberObjectDtoToJSON,
} from './WebApiMemberDtoAddMemberObjectDto';

/**
 * 
 * @export
 * @interface WebApiMemberDtoAddBulkMemberDto
 */
export interface WebApiMemberDtoAddBulkMemberDto {
    /**
     * 
     * @type {Array<WebApiMemberDtoAddMemberObjectDto>}
     * @memberof WebApiMemberDtoAddBulkMemberDto
     */
    members?: Array<WebApiMemberDtoAddMemberObjectDto> | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoAddBulkMemberDto interface.
 */
export function instanceOfWebApiMemberDtoAddBulkMemberDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoAddBulkMemberDtoFromJSON(json: any): WebApiMemberDtoAddBulkMemberDto {
    return WebApiMemberDtoAddBulkMemberDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoAddBulkMemberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoAddBulkMemberDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'members': !exists(json, 'members') ? undefined : (json['members'] === null ? null : (json['members'] as Array<any>).map(WebApiMemberDtoAddMemberObjectDtoFromJSON)),
    };
}

export function WebApiMemberDtoAddBulkMemberDtoToJSON(value?: WebApiMemberDtoAddBulkMemberDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'members': value.members === undefined ? undefined : (value.members === null ? null : (value.members as Array<any>).map(WebApiMemberDtoAddMemberObjectDtoToJSON)),
    };
}

